module.exports = __webpack_public_path__ + "img/Giraffen.9733c7ea.svg";